import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import AccountLeftSidebar from "../../components/AccountLeftSidebar/accountLeftSidebar";
//components
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import { CallMerge } from "@material-ui/icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const Dashboard = (props) => {
  const [value, setValue] = useState({
    user: [],
    userName: "",
  });

  useEffect(() => {
    let data = JSON.parse(localStorage.getItem("user"));
    setValue({ ...value, user: data && data });

    // setTimeout(() => {
    //   const tryAbc = JSON.parse(localStorage.getItem("user"));
    //   setValue({ userName: tryAbc.firstName });
    // }, 2000);
  }, []);

  const { isAuth, user } = props._auth;
  return isAuth && user && user.isVendor ? (
    <Redirect exact to={"/seller-dashboard"} />
  ) : (
    <Fragment>
      <div className="myaccount-page-wrapper wrapper-90 max-1600">
        <BreadCrumb title={`My Account`} />
        <div className="container-fluid myacc-body px-0">
          <div className="row">
            <AccountLeftSidebar />
            <div className="col-md-9">
              <div className="bg-cream myacc-right-info p-3">
                <div className="row">
                  <div className="col-md-6">
                    <div className="myacc-welcome">
                      <h2 className="welcome-to-acc">
                        Welcome {value.user && value.user.firstName}!
                      </h2>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="myacc-balance text-right">
                      <span>Account Balance:</span>
                      <Link to={"/reward-points"}>
                        $
                        {value.user &&
                        value.user.rewardPoints !== 0 &&
                        value.user.rewardPoints !== null
                          ? Number(value.user.rewardPoints).toFixed(2)
                          : Number(0).toFixed(2)}
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="myacc-right-side-heading">
                  <div className="acc-link-heading">
                    <h4>Recent Orders</h4>
                  </div>
                  <span className="orders-info">
                    No orders yet! Check out the&nbsp;
                    <Link to={"/my-orders"}>latest sales.</Link>
                  </span>
                </div>
                <div className="myacc-personal-info">
                  <h4>Personal Info</h4>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="myacc-info-link">
                        <Link to={"/edit-account"} className="myacc-link">
                          <span>
                            <i className="dashboard-icons fas fa-users" />
                          </span>
                          <span>Update Info</span>
                          <span>
                            <i className="fa fa-arrow-right" />
                          </span>
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="myacc-info-link">
                        <Link to={"/change-password"} className="myacc-link">
                          <span>
                            <i className="dashboard-icons fas fa-key"></i>
                          </span>
                          <span>Update Password</span>
                          <span>
                            <i className="fa fa-arrow-right" />
                          </span>
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="myacc-info-link">
                        <div className="myacc-update-address">
                          <Link to={"/address-book"} className="myacc-link">
                            <span>
                              <i className="dashboard-icons fas fa-address-book"></i>
                            </span>
                            <span>Update Address</span>
                            <span>
                              <i className="fa fa-arrow-right" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="myacc-info-link">
                        <div className="myacc-update-address">
                          <Link to="/wishlist" className="myacc-link">
                            <span>
                              <i className="dashboard-icons far fa-list-alt"></i>
                            </span>
                            <span>Modify Wishlist</span>
                            <span>
                              <i className="fa fa-arrow-right" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="acc-link-heading">
                  <h4>My Orders</h4>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <h4 className="link-hint">Order History</h4>
                    <div className="myacc-info-link">
                      <Link to={"/my-orders"} className="myacc-link">
                        <span>
                          <i className="dashboard-icons fas fa-history"></i>
                        </span>
                        <span>View Orders History</span>
                        <span>
                          <i className="fa fa-arrow-right" />
                        </span>
                      </Link>
                    </div>
                    <div className="myacc-info-link">
                      <Link to={"/membership-packages"} className="myacc-link">
                        <span>
                          <i className="dashboard-icons fa fa-dollar-sign"></i>
                        </span>
                        <span>Sundial Membership</span>
                        <span>
                          <i className="fa fa-arrow-right" />
                        </span>
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <h4 className="link-hint">Payment &amp; Rewards</h4>
                    <div className="myacc-quote">
                      <div className="myacc-info-link">
                        <Link to={"/reward-points"} className="myacc-link">
                          <span>
                            <i className="dashboard-icons fas fa-hand-holding-usd"></i>
                          </span>
                          <span>Reward Points</span>
                          <span>
                            <i className="fa fa-arrow-right" />
                          </span>
                        </Link>
                      </div>
                      <div className="myacc-buy-gift-card">
                        <div className="myacc-info-link">
                          <Link to={"/transactions"} className="myacc-link">
                            <span>
                              <i className="dashboard-icons fas fa-comments-dollar"></i>
                            </span>
                            <span>Transactions</span>
                            <span>
                              <i className="fa fa-arrow-right" />
                            </span>
                          </Link>
                        </div>
                        <Link
                          href="transactions.html"
                          target="_blank"
                          className="myacc-link"
                        ></Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="acc-link-heading">
                  <h4>Communication</h4>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <h4 className="link-hint">Newsletter</h4>
                    <div className="myacc-info-link">
                      <Link to={"/newsletter"} className="myacc-link">
                        <span>
                          <i className="dashboard-icons far fa-newspaper"></i>
                        </span>
                        <span>Email</span>
                        <span>
                          <i className="fa fa-arrow-right" />
                        </span>
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <h4 className="link-hint">Membership</h4>
                    <div className="myacc-info-link">
                      <Link to={"/membership-packages"} className="myacc-link">
                        <span>
                          <i className="dashboard-icons far fa-user"></i>
                        </span>
                        <span>Membership</span>
                        <span>
                          <i className="fa fa-arrow-right" />
                        </span>
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <h4 className="link-hint">Need Help?</h4>
                    <div className="myacc-info-link">
                      <Link to={"/customer-service"} className="myacc-link">
                        <span>
                          <i className="dashboard-icons fas fa-question"></i>
                        </span>
                        <span>Help Center</span>
                        <span>
                          <i className="fa fa-arrow-right" />
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="myacc-help-center">
                  <div className="myacc-help"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
const mapStateToProps = (state) => ({
  _auth: state.auth,
});
export default connect(mapStateToProps, {})(Dashboard);
